export const classes = {
  paper: 'rounded-2xl shadow-lg',
};

export const styles = {
  menu: {
    '& .MuiList-root': {
      minWidth: '120px',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
    },
  },
};
